import { DiaryFormRuleTranslation } from "./diary-form-rule-tranlsation.model";

export class DiaryFormRule {
  public id: string;
  public diaryFormId: string;
  public name: string;
  public description: string;
  public expression: string;
  public expressions: DiaryFormConditionExpression[] = [];
  public action: number;
  public logicalOperator: number;
  public messageText: string;
  public messageStyle: string;
  public emailText: string;
  public emailSubject: string;
  public ignoreConditions: boolean;
  public showWhenEntryIncomplete: boolean;
  public showWhenEntryComplete: boolean;
  public translations: DiaryFormRuleTranslation[] = [];

  constructor(init?: Partial<DiaryFormRule>) {
    Object.assign(this, init);

    if (init && init.translations) {
      this.translations = init.translations.map(t => new DiaryFormRuleTranslation(t));
    }

    if (init && init.expression && init.expression.length > 0) {
      this.expressions = JSON.parse(init.expression).map(e => new DiaryFormConditionExpression(e));
    }
  }
}

export class DiaryFormConditionExpression {
  public elementId: string;
  public operator: string;
  public value: string;

  constructor(init?: Partial<DiaryFormConditionExpression>) {
    Object.assign(this, init);
  }

  isValid() {
    return this.elementId && this.operator && this.value;
  }
}
